import { mantineTheme, cssVariables } from '@/config/mantine';
import { createTheme } from '@mantine/core';

const cssPrefix = '--f-';
const toCssVariableName = (val = '') => String(val).replace(/([A-Z])/g, '-$1').toLowerCase();
const theme = createTheme(mantineTheme);

// build css variables to use in mantine, for global use
const variables = {};
Object.keys(cssVariables).forEach((key) => {
  variables[`${cssPrefix}${toCssVariableName(key)}`] = cssVariables[key];
});

const resolver = () => ({ variables });

export {
  theme,
  resolver,
};
